import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, getQueryParameter, LL_H_C, ModuleFE_RoutingV2, Button } from '@nu-art/thunderstorm-frontend/index';
import './PanelWrapper_ResourceManager.scss';
import { Component_SearchAndResults } from '@app/styles';
import { Page_ResourceEditor_V2 } from '@app/hcs-frontend';
import { Panel_ResourceManager_V1_old } from './Panel_ResourceManager_V1_old.js';
import { Dialog_CreateNewResource } from '../dialogs/Dialog_CreateNewResource.js';
export class PanelWrapper_ResourceManager extends ComponentSync {
    constructor(props) {
        super(props);
    }
    deriveStateFromProps(nextProps, state) {
        return { selectedResult: getQueryParameter('selectedResult') };
    }
    onCompleted = (item) => {
        ModuleFE_RoutingV2.goToRoute(Panel_ResourceManager_V1_old.Route, { selectedResult: item._id });
        this.reDeriveState();
    };
    render() {
        return (_jsxs("div", { id: 'resource-manager-panel', className: 'match_parent', children: [_jsx(LL_H_C, { className: 'button-container', children: _jsx(Button, { variant: 'primary', onClick: () => {
                            Dialog_CreateNewResource.show(this.onCompleted);
                        }, children: "ADD RESOURCE" }) }), _jsx(Component_SearchAndResults, { searchItems: [Page_ResourceEditor_V2.SearchableItem_Resource], onSearchItemSelected: () => {
                    } })] }));
    }
}
